import { Link } from 'react-router-dom';
import { Screen } from '../components/Screen';
import { BigButton } from '../components/BigButton';

export function NotFoundScreen() {
  return (
    <Screen>
      <div className="flex-1 flex flex-col justify-center items-center gap-6 text-center py-12">
        <p className="text-sm tracking-wide text-ink/50 uppercase">My Dyslexia Tools</p>
        <h1 className="text-2xl font-semibold">We could not find that page</h1>
        <p className="text-ink/70 max-w-sm">
          The link might be old, or there might be a typo in the address.
        </p>
        <div className="w-full max-w-xs flex flex-col gap-3">
          <Link to="/" className="block">
            <BigButton>Go to the home page</BigButton>
          </Link>
          <Link to="/app" className="block">
            <BigButton variant="secondary">Open the app</BigButton>
          </Link>
        </div>
      </div>
    </Screen>
  );
}
